import React, { useState, useEffect } from "react";
import "./styles/NotificationPopup.css";
import { useNotification } from "../../../shared/contexts/NotificationContext";

interface NotificationPopupProps {}

const NotificationPopup: React.FC<NotificationPopupProps> = () => {
  const {
    isNotificationOpen,
    notificationMessage,
    notificationType,
    notificationOptions,
    notificationId,
    dismissNotification,
  } = useNotification();

  const [isVisible, setIsVisible] = useState(isNotificationOpen);

  useEffect(() => {
    if (isNotificationOpen) {
      setIsVisible(true); // Show the popup
    } else {
      // Delay hiding the popup to allow fade-out animation to complete
      const timeout = setTimeout(() => setIsVisible(false), 400); // Match fade-out duration
      return () => clearTimeout(timeout);
    }
  }, [isNotificationOpen]);

  if (!isVisible) return null;

    const handleClose = () => {
    setIsVisible(false);
  };

  // Only toasts triggered with options (e.g. voice edit's Undo) get a key, a
  // custom duration and an action button; plain toasts render exactly as before.
  const action =
    notificationOptions?.actionLabel && notificationOptions.onAction
      ? { label: notificationOptions.actionLabel, run: notificationOptions.onAction }
      : null;
  const durationS = notificationOptions?.durationMs ? notificationOptions.durationMs / 1000 : null;

  return (
    <div
      key={notificationOptions ? `toast-${notificationId}` : undefined}
      className={`notification-popup notification-${(notificationType || 'info').toLowerCase()}${action ? " notification-has-action" : ""}`}
      role={action ? "status" : undefined}
      style={
        durationS !== null
          ? { animation: `slideInFromBottom 0.4s ease-out, fadeOutToBottom 0.4s ease-in ${durationS}s forwards` }
          : undefined
      }
    >
      <button className="notification-close" onClick={handleClose} aria-label="Close">
        ×
      </button>
      <p>{notificationMessage}</p>
      {action && (
        <button
          type="button"
          className="notification-action"
          onClick={() => {
            dismissNotification();
            setIsVisible(false);
            action.run();
          }}
        >
          {action.label}
        </button>
      )}
      {/* <div className={`progress-bar progress-bar-${notificationType.toLowerCase()}`}></div> */}
    </div>
  );
};

export default NotificationPopup;
